export default '2.4.1';



// WEBPACK FOOTER //
// ./src/lib/version.js